import React from 'react';
import {
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem
} from 'reactstrap';

class DuplicatesFilter extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			dropdownOpen: false,
			filter: 'email'
		};
	}

	toggleSelect = () => {
		this.setState({dropdownOpen: !this.state.dropdownOpen})
	}

	onClick = (filter) => {
		this.setState({filter: filter});
		this.props.updateFilter(filter);
	}

	render() {
		const {dropdownOpen, filter} = this.state;
		return (
			<Dropdown isOpen={dropdownOpen} toggle={this.toggleSelect}>
				<DropdownToggle caret>
					{`Filter by ${filter}`}
				</DropdownToggle>
				<DropdownMenu>
					<DropdownItem header>Filter</DropdownItem>
						<DropdownItem onClick={() => this.onClick("email")}>
							Email
						</DropdownItem>
						<DropdownItem onClick={() => this.onClick("phone")}>
							Phone
						</DropdownItem>
						<DropdownItem onClick={() => this.onClick("both")}>
							Both
						</DropdownItem>
				</DropdownMenu>
			</Dropdown>
		);
	}
}

export default DuplicatesFilter;
